import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IHeaderStyles } from 'src/app/domain/interfaces/views/interface-header-styles';

@Injectable({
  providedIn: 'root'
})
export class HeaderStyleService {
  
  private headerStylesSource = new BehaviorSubject<IHeaderStyles>({
    opacity: 1,
    logo: "",
    class: "bg-dark"
  });

  private headerDiferentPathLogo = new BehaviorSubject<boolean>(false);

  currentheaderStyles = this.headerStylesSource.asObservable();
  IsHeaderDiferentPathLogo = this.headerDiferentPathLogo.asObservable();

  constructor() { }

  setHeaderStyles(headerStyles: IHeaderStyles) {
    this.headerStylesSource.next(headerStyles);
  }

  setHeaderDiferentPathLogo(isDiferent:boolean) {
    this.headerDiferentPathLogo.next(isDiferent);
  }
}
